import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { IconProps } from "./types";

export function CloseIcon({ size, ...props }: IconProps) {
    return <CloseRoundedIcon fontSize={size} {...props} />;
}
